import UtilService from "../../../helper/service";
import * as actionTypes from "../../actions/actionTypes";
import { updateObject } from "../../shared/utility";
import { SESSION_SMALL_THUMBNAIL } from '../../../config/mock';

const initialState = {
  is_loaded: false,
  is_loading: false,
  sessions: [],
  planning: {
    email: null,
    userId: null,
    type: null,
    invited: null,
    link: null,
    plan_to_join: null,
    company: null,
    description: null,
    additional_information: null,
  },
  totalExperience: 0,
  page: 1
};

const reducer = (state = initialState, action: any) => {
  switch (action.type) {

    case actionTypes.PARTICIPANT_EXPERIENCES_GET_SUCCESS:
      const oldSessions: any = [...state.sessions]
      
      const results = action.payload;

      results.sessions.map((item: any) => {
        const objectData: any = {
          name: item.session_title,
          inviter: item.user && item.user.first_name + ' ' + item.user.last_name + ' from ' + item.owner_company,
          img: item.small_thumbnail?item.small_thumbnail:SESSION_SMALL_THUMBNAIL,
          status: item.session_status,
          type: item.session_type,
          length: item.session_length?item.session_length:"Processing...",
          dateTime: item.session_type==="ASYNC"? 'Complete by: ' + UtilService.getSimpleDateTime(item.scheduled_start_at):'Starts: ' + UtilService.getSimpleDateTime(item.scheduled_start_at),
          safety: item.safety_aggregate_index && item.safety_aggregate_index.safety_index?item.safety_aggregate_index.safety_index:"",
          immersion: item.immersion_aggregate_index && item.immersion_aggregate_index.immersion_index ? item.immersion_aggregate_index.immersion_index:"",
          completed: UtilService.getSimpleDate(item.scheduled_end_at),
          scheduled_start_at: item.scheduled_start_at,          
          session_code:item.session_code?item.session_code:'',
          sessionParticipants:item.sessionParticipants?item.sessionParticipants:[],
        }
     
     
        if (!oldSessions.find((val: any) => val.session_code === item.session_code)) {
          oldSessions.push(objectData)
        } else {
          let index: any = ''
          for (let j = 0; j < oldSessions.length; j++) {
            if (oldSessions[j].session_code === item.session_code) {
              index = j
            }
          }
          if (index !== '') {
            oldSessions[index] = objectData
          }
        }
        return objectData
      })

      return updateObject(state, {
        sessions: oldSessions,
        totalExperience: results.count,
        is_loaded: true,
      });

    case actionTypes.UPDATE_PAGE:
      return updateObject(state, {
        page: action.payload
      });

    case actionTypes.SET_PARTICIPENT_EXPERIENCE_LOADING:
      return updateObject(state, {
        is_loading: action.payload,
      });
    
    case actionTypes.UPDATE_PLANNING_VALUE:

      const newValue: any = {...state.planning,  [action.payload.param]: action.payload.value}

      return updateObject(state, {
        planning: newValue,
      });

    default:
      return state;
  }
};

export default reducer;
